<template>
  <div
    class="range-badge"
    :class="{
      'range-badge__positive': props.inRange,
      'range-badge__negative': !props.inRange,
    }"
  >
    {{ props.inRange ? $t('pools.inRange') : $t('pools.outOfRange') }}
  </div>
</template>
<script lang="ts" setup>
interface IProps {
  inRange: boolean;
}

const props = defineProps<IProps>();
</script>

<style src="./style.scss" lang="scss" scoped />
